import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import CommunityForm from '../components/CommunityForm';
import CUser from "core/components/CUser/CUser";
import { useUser } from "modules/Auth/hooks";
import { _t } from "core/language";

export default function CommunityCreatePage() {
  const { userInfo } = useUser();

  return (
    <AppLayout className={` relative no-scrollbar`}>
      <PageHeader
        className="sticky top-0 w-full z-[200] bg-white"
        title={_t("comunity.create.title")}
        showCart={false}
      />
      <div className="px-4 mt-[13px] mb-3">
        <CUser
          avatar={userInfo?.avatar?.url?.thumbnail}
          name={userInfo?.name || `@${userInfo.username}`}
          disableClick
        />
      </div>
      <div className="px-4">
        <CommunityForm />
      </div>
    </AppLayout>
  );
}
